import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { Auth } from '../../helpers/amplifyAuthCompat';
import { Logout as IconLogout } from '../Icons/Logout';
import './styles.scss';

import { MenuLink } from '../../components/MenuLink';
import { closeSession } from '../../helpers/utils';
import { loadingActions } from '../../redux/actions/loadingActions';

export const Navbar = () => {
	const dispatch = useDispatch();
	const linksEl = useRef(null);
	const initialCountdownValue = 15 * 60;
	const [countdown, setCountdown] = useState(initialCountdownValue);
	const bgc = `#${process.env.REACT_APP_TOOLBAR_COLOR}`;
	const { user, grupoLabel, menues } = useSelector((state) => state.uReducer);
	const grantedMenues = menues ? menues.split(',') : [];

	const Logout = () => {
		dispatch(loadingActions.show());
		Auth.signOut()
			.then(() => {
				closeSession();
			})
			.finally(() => {
				dispatch(loadingActions.close());
			});
	};

	const formatCountdown = () => {
		const minutes = Math.floor(countdown / 60);
		const seconds = countdown % 60;
		return `${minutes}:${seconds.toString().padStart(2, '0')}`;
	};

	const resetTimer = () => {
		setCountdown(initialCountdownValue);
	};

	useEffect(() => {
		const intervalId = setInterval(() => {
			setCountdown((prevCountdown) => {
				if (prevCountdown === 1) {
					Logout();
				}
				return prevCountdown - 1;
			});
		}, 1000);
		return () => clearInterval(intervalId);
	}, []);

	useEffect(() => {
		const events = ['mousemove', 'keypress', 'click', 'scroll', 'touchstart'];
		const resetTimerOnActivity = () => resetTimer();
		events.forEach((event) =>
			window.addEventListener(event, resetTimerOnActivity),
		);

		return () => {
			events.forEach((event) =>
				window.removeEventListener(event, resetTimerOnActivity),
			);
		};
	}, []);

	const handleMenu = (e) => {
		const elem = e.target;
		const elemLink = linksEl.current;

		elemLink.classList.toggle('is-open');
		elem.classList.toggle('is-open');
	};

	return (
		<header>
			<div className="header" style={{ backgroundColor: bgc }}>
				<h1 className="header__title">Talentos TI</h1>
				<p>{formatCountdown()}</p>
				<nav className="navbar">
					<div className="navbar__links" ref={linksEl}>
						<ul className="menu">
							{(grantedMenues.includes('*') ||
								grantedMenues.includes('home')) && (
								<li>
									<div className="menu__link">
										<NavLink to="/home">Liquidación de mes</NavLink>
									</div>
								</li>
							)}
							{(grantedMenues.includes('*') ||
								grantedMenues.includes('mantenimiento')) && (
								<li>
									<div className="menu__inner">Mantenimiento</div>
									<div className="submenu">
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('persons');
											})()}
											to="/persons"
											text="Personas"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('squads');
											})()}
											to="/squads"
											text="Squads"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('talent');
											})()}
											to="/talent"
											text="Talentos"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('candidates');
											})()}
											to="/candidates"
											text="Candidatos"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('tribus');
											})()}
											to="/tribus"
											text="Tribus"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('cecoArea');
											})()}
											to="/ceco-areas"
											text="Ceco de Area"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('gestion-permisos');
											})()}
											to="/gestion-permisos"
											text="Gestion de Roles"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('perfiles');
											})()}
											to="/perfiles"
											text="Perfiles"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('proveedores');
											})()}
											to="/proveedores"
											text="Proveedores"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('parametros');
											})()}
											to="/parametros"
											text="Parámetros"
										/>
									</div>
								</li>
							)}
							{(grantedMenues.includes('*') ||
								grantedMenues.includes('planeamiento')) && (
								<li>
									<div className="menu__inner">Planeamiento</div>
									<div className="submenu">
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('programs');
											})()}
											to="/programs"
											text="Programas"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('projects');
											})()}
											to="/projects"
											text="Proyectos"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('talentoxproyecto');
											})()}
											to="/talentoxproyecto"
											text="Talentos por Proyecto"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('execution');
											})()}
											to="/execution"
											text="Gestión de Execution"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('cal');
											})()}
											to="/cal"
											text="Gestión de CAL"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('projects-nextq');
											})()}
											to="/projects-nextq"
											text="Proyectos para el próximo Q"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('projects-prevq');
											})()}
											to="/projects-prevq"
											text="Importar proyectos del Q anterior"
										/>
									</div>
								</li>
							)}
							{(grantedMenues.includes('*') ||
								grantedMenues.includes('staffing')) && (
								<li>
									<div className="menu__inner">Staffing</div>
									<div className="submenu">
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('talent-requests');
											})()}
											to="/talent-requests"
											text="Solicitud de talentos"
										/>
										{/* <MenuLink
                      condition={(() => {
                        return grantedMenues.includes('surcease');
                      })()}
                      to="/surcease"
                      text="Ceses"
                    />  */}
									</div>
								</li>
							)}
							{(grantedMenues.includes('*') ||
								grantedMenues.includes('reportes')) && (
								<li>
									<div className="menu__inner">Consultas y reportes</div>
									<div className="submenu">
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('reports');
											})()}
											to="/reports"
											text="Reportes"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('requests');
											})()}
											to="/requests"
											text="Consulta requerimientos"
										/>
									</div>
								</li>
							)}
							{(grantedMenues.includes('*') ||
								grantedMenues.includes('administrador')) && (
								<li>
									<div className="menu__inner">Administrador</div>
									<div className="submenu">
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('project-assignment');
											})()}
											to="/project-assignment"
											text="Asignación de proyectos"
										/>
										<MenuLink
											condition={(() => {
												return grantedMenues.includes('admin');
											})()}
											to="/admin"
											text="Gestión"
										/>
									</div>
								</li>
							)}
						</ul>
						<div
							className="navbar__logout"
							onClick={Logout}
							title="Cerrar sesión"
						>
							<IconLogout className="logout__icon" />
							<span className="logout__text">Cerrar sesión</span>
						</div>
					</div>
					<div className="navbar__user" title={grupoLabel}>
						{user}
					</div>
				</nav>
				<div className="burger" onClick={handleMenu}>
					<div></div>
				</div>
			</div>
		</header>
	);
};
